module.exports = __webpack_public_path__ + "img/reports_title.5a916a97.svg";